import BackgroundOld from "../Components/BackgroundOld";
import React, { useState } from 'react';
import { Box, Typography, } from '@mui/material';
import { Divider } from '@mui/material';
import DrawIcon from '@mui/icons-material/Draw';
import useMediaQuery from '@mui/material/useMediaQuery';
import photo from '../Assets/photo_black.jpg'
import { useNavigate } from 'react-router-dom';
import { ROUTE_HOME_PAGE } from "../utils";
import logoReact from '../Assets/logo192.png';
import nodeLabel from '../Assets/Node_logo.png';
import logoCss from '../Assets/css_logo.png';
import logoMui from '../Assets/mui_logo2.png';
import stampUp from '../css/stampUp.module.css';
import running from '../css/running.module.css';
import postgre_logo from  '../Assets/Postgre_logo.svg';
import bootstrap_logo from  '../Assets/bootstrap.svg';
import ex_01 from '../Assets/example001.png';
import ex_02 from '../Assets/example002.png';
import ex_03 from '../Assets/example003.png';
import ex_04 from '../Assets/example004.png';
import bad from '../Assets/bad.png';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import logo_telegramm from '../Assets/telegram.png';
import logo_facebook from '../Assets/facebook.png';
import logo_viber from '../Assets/viber.png';
import cont from '../css/vibro.module.css';
import logoMail from '../Assets/message.png';
import swing from '../css/swing.module.css';
import ModalMail from "./ModalMail";

function OldPaper() {
    const [modal,setModal] = useState();
    const [language,setLenguage] = useState(true);
    const matches = useMediaQuery('(min-width:1000px)');
    const navigate = useNavigate();

// const example_img =[{image:ex_01,title: language ? 'Интернет-магазин климатического оборудования: страница каталога.Серверная часть этого каталога работает с помощью headless cms "Strapi", дизайн интерфейса выполнен с помощью библиотеки React,библиотеки компонентов "Material UI"':'Online store of climate control equipment: catalog page.The server part of this catalog works with the help of headless cms "Strapi", the interface design is made with the help of the library React, React component library "Material UI"'},
//     {image:ex_02,title: language  ?'Интернет-магазин климатического оборудования: "О нас". "Strapi", "Material UI", "React"' : 'Online store of climate control equipment: page About. "Strapi", "Material UI", "React"'},
//     {image:ex_04,title: language ? 'Сайт-портфолио.На основе Фреймворка с открытым исходным кодом  Gatsby React':'Portfolio website. Gatsby  React-based open source framework'},
//     {image:ex_03,title: language  ?'Сайт туристического агенства.На основе Фреймворка с открытым исходным кодом  Gatsby React': 'Travel agency website. Gatsby  React-based open source framework'},
//     {image:bad,title: language ? 'Интернет-магазин по продаже бадов. Серверная часть этого интернет-магазина работает на Node JS, DB Postgress, ORM Sequalize, фронтенд библиотека - React ':'Online store selling dietary supplements. The server part of this online store runs on Node JS, DB Postgress, ORM Sequalize, frontend library - React'}];
const example_img =[{ image:ex_01,title: 'Online store of climate control equipment: catalog page.The server part of this catalog works with the help of headless cms "Strapi", the interface design is made with the help of the library React, React component library "Material UI"'},
  {image:ex_02,title: 'Online store of climate control equipment: page About. "Strapi", "Material UI", "React"'},
  {image:ex_04,title:'Portfolio website. Gatsby  React-based open source framework'},
  { image:ex_03,title: 'Travel agency website. Gatsby  React-based open source framework'},
  {image:bad,title:'Online store selling dietary supplements. The server part of this online store runs on Node JS, DB Postgress, ORM Sequalize, frontend library - React'}];

    function changeLanguage(){
        setLenguage(!language ? true : false);      
    };
function setContact(e){
  navigate(e)
};
function openModal(){
    setModal(true)
};
function closeModal(value){
    setModal(value)
};

function openSendEmail(){
  navigate('http://localhost:8002/api/sendemail')
};
    return (
      <>
      <BackgroundOld/>
      <header>
        <Box sx={{display:'flex',alignItems:'center',justifyContent:'space-between',width:1600,maxWidth:'100%',marginLeft:'auto',marginRight:'auto',minHeight:'80px'}}>
     
        <DrawIcon sx={{marginLeft:3,cursor:'pointer'}}/>
        <Typography fontFamily='Special Elite Regular' variant='h6' sx={{cursor:'pointer'}} onClick={()=>setContact(ROUTE_HOME_PAGE)}>webdesign.pro</Typography>
        <Typography sx={{marginRight:3,cursor:'pointer',fontWeight:'800'}} onClick={()=>{
                changeLanguage();
                
                }}>EN</Typography>
        
        </Box>
      </header>
      <Divider/>
     <main>

<Box sx={{display:'flex',width:'100%',marginLeft:'auto',marginRight:'auto',justifyContent:'center',marginTop:3}}>
<Typography variant={matches ? 'h2' : 'h4'}sx={{marginTop:'20px',textAlign:'center'}} fontFamily='Creepster Cyrillic Regular' >
       Unique solutions for you 
  </Typography>
</Box>

{matches ?<Box sx={{display:'flex', maxWidth:1900,marginLeft:'auto', marginRight:'auto',marginTop:5,justifyContent:'space-evenly'}}>

  <Box sx={{maxWidth:800}} fontFamily='Creepster Cyrillic Regular' >
  <Typography variant='h5'sx={{marginTop:'20px',textAlign:'left'}} fontFamily='Special Elite Regular' >
           Hello. My name is Andrey. I have always liked bringing ideas to reality, so i got into web application development. It was a hobby at first, but over time it became my favorite job. 
  </Typography>
  <Typography sx={{marginTop:'20px',textAlign:'left'}} variant='h5' fontFamily='Special Elite Regular' >{'My experience: i will help you create an online trading platform, an electronic catalog of your products, a personal blog, chat, portfolio and other useful applications.' }
  </Typography>
  
  <Typography variant='h5' sx={{marginTop:'20px',textAlign:'left'}} fontFamily='Special Elite Regular' >{'My stack: ' }
    {'React JS, Next JS, Material UI, Bootstrap, Postgre_sql, Node JS, JS, TS, HTML, CSS, Apollo Client, Rest_api, Graph_ql, Strapi, Mob_x, Redux, Sequalize'}</Typography>
  </Box> 

  <Box sx={{alignContent:'center'}}><img src={photo} style={{opacity:'0.8',height:310}}/></Box>

  </Box> :

  <Box sx={{ maxWidth:1900,marginLeft:'auto', marginRight:'auto',marginTop:5}}>

  <Box sx={{maxWidth:800, padding:'20px'}}>
  <Typography variant='h5'sx={{marginTop:'20px',textAlign:'left'}} fontFamily='Special Elite Regular' >{ 'Hello. My name is Andrey. I have always liked bringing ideas to reality, so i got into web application development. It was a hobby at first, but over time it became my favorite job.' }
  </Typography>
  <Typography sx={{marginTop:'20px',textAlign:'left'}} variant='h5' fontFamily='Special Elite Regular' >{'My experience: i will help you create an online trading platform, an electronic catalog of your products, a personal blog, chat, portfolio and other useful applications.' }
  </Typography>
  
  <Typography variant='h5' sx={{marginTop:'20px',textAlign:'left'}} fontFamily='Special Elite Regular' >{'My stack: ' }
    {'React JS, Next JS, Material UI, Bootstrap, Postgre_sql, Node JS, JS, TS, HTML, CSS, Apollo Client, Rest_api, Graph_ql, Strapi, Mob_x, Redux, Sequalize'}</Typography>
  </Box> 

  <Box sx={{display:'flex',justifyContent:'center',}}>
    <img src={photo} style={{height:310}}/>
    </Box>
  </Box>
  }
 
  {matches ? <><Box sx={{display:'flex',justifyContent:'space-between',marginTop:8,marginLeft:10,marginRight:10, flexWrap:'wrap',filter:'grayscale(100%)', maxWidth:1200,marginLeft:'auto', marginRight:'auto'}}>
<img src={bootstrap_logo} style={{width:'100px',height:'100px',borderRadius:'10px'} }/>
<Box><img src={nodeLabel} style={{width:'200px',height:'100px',borderRadius:'10px',filter:'grayscale(100%)'}}/></Box>
       
       <Box ><img src={postgre_logo} style={{width:'100px',height:'100px',borderRadius:'10px'}}/></Box>
       <Box className={running.block}><img  src={logoReact} style={{width:'100px',height:'100px'}}/></Box>
       <Box ><img src={logoMui} style={{width:'100px',height:'100px',borderRadius:'10px'}}/></Box>
       
</Box> </> :<Box sx={{display:'flex', justifyContent:'center',filter:'grayscale(100%)'}}>
       <Box ><img src={postgre_logo} style={{width:'100px',height:'100px',borderRadius:'10px'}}/></Box>
       <Box className={running.block}><img  src={logoReact} style={{width:'100px',height:'100px'}}/></Box>
       <Box ><img src={logoMui} style={{width:'100px',height:'100px',borderRadius:'10px'}}/></Box>
       </Box>} 
       <Box sx={{display:'flex',justifyContent:'center',marginTop:5}}>
        <Typography className={stampUp.type1} variant='h5' fontFamily='Special Elite Regular'>{'EXAMPLES OF MY WORK'}</Typography>      
        </Box>
        <Box sx={{  filter:'grayscale(100%)', maxWidth:1400,marginLeft:'auto',marginRight:'auto'}}>
       <ImageList variant="masonry" cols={2} gap={15}>
        {example_img.map((item) => (
          <ImageListItem key={item.image}  >
            <img
              srcSet={`${item.image}?w=248&fit=crop&auto=format&dpr=2 2x`}
              src={`${item.image}?w=248&fit=crop&auto=format`}
              alt={item.title}
              loading="lazy"
            />
            
            <Typography variant="h6" fontFamily='Creepster Cyrillic Regular' >{item.title}</Typography>
            
          </ImageListItem>
        ))}
      </ImageList>
      </Box>
             
<ModalMail openMail={modal} closeMail={closeModal}/>
     </main>
     <Divider/>
     <footer>
     <Box sx={{display:'flex',justifyContent:'center',marginTop:5}}>
        <Typography className={stampUp.type1} variant='h6' fontFamily='Special Elite Regular'>{'Contact me'}</Typography>      
        </Box>
        <Box sx={matches ? {display:'flex',justifyContent:'center',top:'20px',filter:'grayscale(100%)'}:
    {display:'flex', zIndex:'20',justifyContent:'center',filter:'grayscale(100%)'}}>
         

        <a href='https://t.me/Klimat1812'><img   src={logo_telegramm} alt="" style={{maxWidth:'50px',maxHeight:'50px',margin:'10px'}} /></a>
        <a href='viber://chat?number=380677051399'><img className={ cont.wibro } src={logo_viber} alt="" style={{maxWidth:'60px',maxHeight:'60px',margin:'20px'}} /></a>
        <a href='https://www.facebook.com/profile.php?id=100015060969349'><img src={logo_facebook} alt="" style={{maxWidth:'50px',maxHeight:'50px',margin:'10px'}} /></a>
        <a ><img onClick={openModal} className={swing.swing} src={logoMail} alt="" style={{maxWidth:'50px',maxHeight:'50px',margin:'20px'}} /></a>
        
        </Box>
<Box>
    <Typography variant='h6' sx={{marginTop:'20px',textAlign:'center'}} fontFamily='Special Elite Regular'>webdesign.pro<br></br> 2024</Typography>
</Box>
     </footer>
      </>
    );
  }
  
  export default OldPaper;